<ul class="ob1-item-card-list apply-one-grid apply-one-style mb-2 mt-2">
  @for (info of infos; track info; let last = $last) {
    <li [class.mb-1]="!last">
      <ng-container
        [ngTemplateOutlet]="info.content && info.content.length > 1 ? interactiveInfo : simpleInfo"
        [ngTemplateOutletContext]="{ info: info }"
      >
      </ng-container>
    </li>
  }
</ul>

<ng-template #interactiveInfo let-info="info">
  <div
    class="alert-container ob1-notification-message alert-info info-content no-border"
    [attr.data-e2e]="'e2e-push-helps-' + info?.code"
  >
    <a
      ecmPushTracker
      [ecmDisabledAction]="isEclair && !AdviseWhitelistEclairConstants.WHITELIST.includes(info.code?.toUpperCase())"
      [attr.data-e2e]="'e2e-push-helps-btn-' + info?.code"
      [attr.id-ref-zone]="info?.idRefZone"
      [pdb-zid]="zid"
      [pdb-sc]="'adv'"
      [pdb-ta]="info.advTracker"
      [pdb-idc]="info.code"
      [href]="info.href"
      (click)="openLink(info); (false)"
      class="info-content ob1-item-card alert-info no-border px-2 px-md-1"
    >
      @if (info.imageUrl) {
        <img alt="" class="push-info-icon" src="{{ getImgFormat(info.imageUrl) }}" />
      }
      <div class="ob1-item-card-container content-picto">
        <div class="ob1-item-card-text">
          <strong>{{ info.title }}</strong>
          <ul class="list">
            @for (infoHelp of info.content; track infoHelp) {
              <li>{{ infoHelp }}</li>
            }
          </ul>
        </div>
      </div>
    </a>
  </div>
</ng-template>

<ng-template #simpleInfo let-info="info">
  @if (info.href) {
    <div
      class="alert-container ob1-notification-message alert-info no-border"
      [attr.data-e2e]="'e2e-push-helps-' + info?.code"
      [ngClass]="{ 'info-content': info.content }"
    >
      <a
        ecmPushTracker
        [attr.data-e2e]="'e2e-push-helps-btn-' + info?.code"
        [pdb-zid]="zid"
        [pdb-sc]="'adv'"
        [pdb-ta]="info.advTracker"
        [pdb-idc]="info.code"
        [href]="info.href"
        (click)="openLink(info); (false)"
        class="ob1-item-card alert-info px-1 px-md-1 no-border"
        [ngClass]="{ 'info-content': info.content }"
      >
        @if (info.imageUrl) {
          <img alt="" class="push-info-icon" src="{{ getImgFormat(info.imageUrl) }}" />
        }
        @if (!info.imageUrl) {
          <span class="icon icon-info push-info-icon" aria-hidden="true"></span>
        }
        <div class="ob1-item-card-container" [ngClass]="{ 'content-picto': info.content }">
          <div class="ob1-item-card-text">
            <strong>{{ info.title }}</strong>
            @if (info?.content) {
              <small class="ob1-item-card-desc push-info-desc text-mw">
                {{ info?.content }}
              </small>
            }
          </div>
        </div>
      </a>
    </div>
  } @else {
    <div class="alert-container alert-info info-content no-border" [attr.data-e2e]="'e2e-push-helps-' + info?.code">
      <p class="alert alert-info" role="alert">
        <span class="alert-icon" aria-hidden="true"></span>
        <span class="ob1-alert-title">{{ info.title }}</span>
      </p>
    </div>
  }
</ng-template>
